import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as Stomp from '@stomp/stompjs';
import { ToastService } from './toast.service';
import { NotificationType } from '../enums/notificationType';
import { StorageKey } from '../enums/storageKey';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  private stompClient!: Stomp.Client;

  constructor(private toastService: ToastService) {}

  connect() {
    console.info('Websocket connecting..');

    const accessToken = localStorage.getItem(StorageKey.AccessToken);
    this.stompClient = new Stomp.Client({
      brokerURL: `${environment.apiUrl}/websocket`,
      connectHeaders: {
        Authorization: `Bearer ${accessToken}`
      },
      reconnectDelay: 5000
    });

    this.stompClient.onConnect = () => {
      console.info('Websocket connected.');

      this.stompClient.subscribe('/user/queue/notifications', message => {
        try {
          const parsedMessage = JSON.parse(message.body);
          this.toastService.show(parsedMessage.title, parsedMessage.body, NotificationType.Info);
        } catch (error) {
          console.error('Error parsing message:', error);
        }
      });
    };

    this.stompClient.onStompError = frame => {
      console.error('Broker error:', frame.headers['message']);
    };

    this.stompClient.activate();
  }

  disconnect() {
    this.stompClient?.deactivate();
    console.info('Websocket disconnected.');
  }
}
